// equalHeight

(function () {
    equalHeight(false);
})();

window.addEventListener('resize', function () {
    equalHeight(true);
});
window.addEventListener('load', function () {
    equalHeight(true);
}, false);

function equalHeight(resize) {
    const groups = new Map();
    document.querySelectorAll(".equalHeight").forEach(el => {
        const groupKey = el.getAttribute('data-group') ?? -1;
        const elements = groups.has(groupKey) ? groups.get(groupKey) : [];
        elements.push(el);
        groups.set(groupKey, elements);
    });
    groups.forEach(elements => {
        let allHeights = [],
            i = 0;
        if (resize === true) {
            for (i = 0; i < elements.length; i++) {
                elements[i].style.height = 'auto';
            }
        }
        for (i = 0; i < elements.length; i++) {
            allHeights.push(elements[i].clientHeight);
        }
        const maxHeight = Math.max.apply(Math, allHeights);
        for (i = 0; i < elements.length; i++) {
            elements[i].style.height = maxHeight + 'px';
        }
    });
}